// extracted by mini-css-extract-plugin
module.exports = {"main":"QsrScheduledOrderStatus_main__jA8_W","status":"QsrScheduledOrderStatus_status__mI4G3"};